import { useQuery } from '@tanstack/react-query';
import { booksellerAuthConfigsService } from '../api/booksellerAuthConfigsService';

export function useBooksellerAuthConfig(booksellerId: string | null) {
  return useQuery({
    queryKey: ['manage-bookseller-auth-config', booksellerId],
    queryFn: () => booksellerAuthConfigsService.getFirstByBooksellerId(booksellerId!),
    enabled: !!booksellerId,
    staleTime: 30_000,
  });
}
